// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionOrderPayment_wrapper__1Bl1e","greenBackground":"SectionOrderPayment_greenBackground__zIrSF"};